<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <PropertyFinalityForm
        :data="formData"
        @update="updateForm"
        :errors="formErrors"
        :editing="isEditing"
      />

      <div class="mt-3">
        <BfButton
          v-if="!isEditing"
          @click="createFinalidad"
        >
          Guardar
        </BfButton>
        <BfButton
          v-if="isEditing"
          variant="red"
          @click="showDeleteModal"
        >
          Eliminar
        </BfButton>

        <DeleteWarningModal
          v-model="displayDeleteModal"
          title="¿Desea eliminar este dato?"
          @confirm-deletion="deleteFinalidad"
        />
      </div>
    </template>
  </PageWrap>
</template>

<script>
import PropertyFinalityForm from '@/components/FormGroups/PropertyFinalityForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import { propertyFinalityTypeAPI } from '@/api';

export default {
  name: 'PropertyFinalitiesDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [data = {}],
      } = await propertyFinalityTypeAPI.get(this.id);

      this.formData = data;
    },

    async prepareForm() {
      const { data } = propertyFinalityTypeAPI.preCreate();
      this.formData = data;
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await propertyFinalityTypeAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },

    async createFinalidad() {
      try {
        this.formErrors = {};
        const { data, message } = await propertyFinalityTypeAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({
          name: 'finalidadinmueble',
          params: { id: `${data.id}` },
        });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        });
      }
    },

    async deleteFinalidad() {
      try {
        const { message } = await propertyFinalityTypeAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'finalidadinmuebles' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing
        ? `Finalidad: ${this.formData.nombre || ''}`
        : 'Crear Finalidad de Inmueble';
    },
  },

  components: {
    DeleteWarningModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
    PropertyFinalityForm,
  },
};
</script>
